import { Link, Typography, Breadcrumbs as Crumbs } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RoutePath, RouteDisplay } from '../util/Routes';
const useStyles = makeStyles(() =>
  createStyles({
    crumb: {
      cursor: 'pointer',
      fontSize: 14,
      textTransform: 'uppercase',
    },
    noActionCrumb: {
      cursor: 'default',
      fontSize: 14,
      textTransform: 'uppercase',
    },
  }),
);
interface Crumb {
  path: string;
  text: string;
}
interface BreadcrumbsProps extends RouteComponentProps {
  className?: string;
  tenantName: string;
  lastTabPath?: string;
}
const Breadcrumbs: React.FC<BreadcrumbsProps> = (props: BreadcrumbsProps) => {
  const classes = useStyles();
  const { history, location, className, tenantName, lastTabPath } = props;
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  const getRouteDisplayText = (path: string) => {
    switch (path) {
      case RoutePath.Payments:
        return RouteDisplay.Payments;
      case RoutePath.Payment:
        return RouteDisplay.Payment;
      case RoutePath.UserManagement:
        return RouteDisplay.UserManagement;
      case RoutePath.History:
        return RouteDisplay.History;
      case RoutePath.Home:
        // Already home.
        return undefined;
      default:
        // Unknown route to our switch, show route
        return path;
    }
  };
  useEffect(() => {
    const startingPath = location.pathname;
    if (startingPath !== '' && startingPath !== '/' && startingPath !== RoutePath.Home) {
      const startingCrumb = {
        path: startingPath,
      } as Crumb;
      // If the loading apps initial path has a value, and its not home, set it in the intial crumbs.
      const displayText = getRouteDisplayText(startingPath);
      if (displayText) {
        startingCrumb.text = displayText;
        setCrumbs([startingCrumb]);
      }
    }
    const unlisten = history.listen(location => {
      setCrumbs([{ path: location.pathname, text: getRouteDisplayText(location.pathname) } as Crumb]);
    });
    // returned function will be called on component unmount
    return () => {
      unlisten();
    };
  }, []);
  return (
    <Crumbs aria-label="breadcrumb" className={className}>
      <Typography variant={'label1'}>
        <Link
          underline="hover"
          className={classes.crumb}
          color="primary"
          onClick={() => {
            history.push(RoutePath.Home);
          }}
        >
          {RouteDisplay.Home}
        </Link>
      </Typography>
      {crumbs.length === 0 && (
        <Typography variant={'label1'} className={classes.noActionCrumb}>
          {tenantName}
        </Typography>
      )}
      {crumbs.length > 0 && tenantName && (
        <Typography variant={'label1'}>
          <Link
            underline="hover"
            className={classes.crumb}
            color="primary"
            onClick={() => {
              // In the case of payer portal, home brings us to the last tab path, or payments tab if no last tab is found.
              history.push(lastTabPath || RoutePath.Payments);
            }}
          >
            {tenantName}
          </Link>
        </Typography>
      )}
      {crumbs?.map((crumb: Crumb, index: number) => {
        if (index === crumbs.length - 1 || crumbs.length === 1) {
          return (
            <Typography variant={'label1'} key={index} className={classes.noActionCrumb}>
              {crumb.text}
            </Typography>
          );
        }
        return (
          <Typography variant={'label1'} key={index}>
            <Link
              underline="hover"
              className={classes.crumb}
              color="primary"
              onClick={() => {
                history.push(crumb.path);
              }}
            >
              {crumb.text}
            </Link>
          </Typography>
        );
      })}
    </Crumbs>
  );
};

export default withRouter(Breadcrumbs);
